import { BreakpointRangeValue, isAtMostMobile, isAtMostTablet } from '@optimus-web/core';

export const getTemplateColumnsGridSize = (breakpointRange?: BreakpointRangeValue) => {
    if (breakpointRange && isAtMostMobile(breakpointRange)) {
        return 'repeat(1, 1fr)';
    }
    if (breakpointRange && isAtMostTablet(breakpointRange)) {
        return 'repeat(2, 1fr)';
    }

    return 'repeat(3, 1fr)';
};
